import request from '@/utils/request'

// 获取作品列表
export function getCollectionList(params) {
  return request({
    url: '/gateway/collection/list',
    method: 'get',
    params
  })
}

// 获取作品详情
export function getCollectionDetail(id) {
  return request({
    url: `/gateway/collection/${id}`,
    method: 'get'
  })
}